import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "remote-daily-event-item" }
const _hoisted_2 = { class: "remote-daily-event-item__info" }
const _hoisted_3 = { class: "remote-daily-event-item__info-meta label-mono-xs" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = { class: "remote-daily-event-item__info-general label-s" }
const _hoisted_6 = { class: "remote-daily-event-item__camera" }
const _hoisted_7 = {
  key: 0,
  class: "remote-daily-event-item__info-item"
}
const _hoisted_8 = {
  key: 1,
  class: "remote-daily-event-item__info-item"
}
const _hoisted_9 = {
  key: 2,
  class: "remote-daily-event-item__info-item"
}
const _hoisted_10 = {
  key: 3,
  class: "remote-daily-event-item__info-item"
}
const _hoisted_11 = { class: "remote-daily-event-item__puppet" }
const _hoisted_12 = { class: "remote-daily-event-item__confidence" }
const _hoisted_13 = {
  key: 1,
  class: "remote-daily-event-item__no-card heading-3xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NDateTimeLabel = _resolveComponent("NDateTimeLabel")!
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_Confidence = _resolveComponent("Confidence")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "#" + _toDisplayString(_ctx.item.id), 1),
        _hoisted_4,
        _createVNode(_component_NDateTimeLabel, {
          modelValue: _ctx.item.external_timestamp,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.external_timestamp) = $event)),
          size: "m",
          class: "remote-daily-event-item__date"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item.camera), 1),
        (_ctx.item.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.item.name), 1))
          : _createCommentVNode("", true),
        (_ctx.item.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.item.address), 1))
          : _createCommentVNode("", true),
        (_ctx.item.latitude && _ctx.item.longitude)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('common.location', 'f')) + ": " + _toDisplayString(_ctx.item.latitude) + ", " + _toDisplayString(_ctx.item.longitude), 1))
          : _createCommentVNode("", true),
        (_ctx.item.azimuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('common.azimuth', 'f')) + ": " + _toDisplayString(_ctx.item.azimuth) + "°", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.item.puppet_id), 1)
      ])
    ]),
    _createVNode(_component_NThumbnail, {
      size: "large",
      class: "remote-daily-event-item__thumbnail",
      "model-value": _ctx.item.thumbnail,
      onClick: _ctx.showItemImage
    }, null, 8, ["model-value", "onClick"]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.item.confidence)
        ? (_openBlock(), _createBlock(_component_Confidence, {
            key: 0,
            value: _ctx.item.confidence,
            direction: "vertical",
            objects: _ctx.ObjectsTypesMap.Faces
          }, null, 8, ["value", "objects"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasCard)
      ? (_openBlock(), _createBlock(_component_NThumbnail, {
          key: 0,
          size: "large",
          class: "remote-daily-event-item__thumbnail",
          "model-value": _ctx.cardThumbnail,
          onClick: _ctx.showCardImage
        }, null, 8, ["model-value", "onClick"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('remote_monitoring.unmatched', 'u')), 1))
  ]))
}